// Main Stimulus controllers index
// Import and register all main controllers (public-facing)

import { application } from "./application"

import TextareaAutogrow from "stimulus-textarea-autogrow"
import AttachmentsController from "./attachments_controller"
import NavbarController from "./navbar_controller"
import DismissibleController from "./dismissible_controller"
import SliderController from "./slider_controller";
import LightboxController from "./lightbox_controller";
import ClipboardController from "./clipboard_controller";
import DownloadController from "./download_controller";
import PricesController from "./prices_controller";
import UmamiController from "./umami_controller";
import RecaptchaController from "./recaptcha_controller";

application.register("navbar", NavbarController);
application.register("dismissible", DismissibleController);
application.register("attachments", AttachmentsController);
application.register("slider", SliderController)
application.register("lightbox", LightboxController)
application.register("clipboard", ClipboardController);
application.register("download", DownloadController);
application.register("prices", PricesController);
application.register("umami", UmamiController);
application.register("recaptcha", RecaptchaController);
application.register("textarea-autogrow", TextareaAutogrow);
